import React from "react";

export default function CharacterHUD({ adventure }) {
  const { stats, inventory, hard_mode, undos_remaining, is_dead, chapter } = adventure;
  return (
    <div className="p-4 space-y-5 font-mono text-xs">
      <div>
        <div className="text-[0.6rem] uppercase tracking-widest gold mb-2">Status</div>
        <div className="grid grid-cols-2 gap-2">
          <StatChip label="Chapter" value={chapter} />
          <StatChip label="Mode" value={hard_mode ? "HARD" : "Casual"} accent={hard_mode ? "red" : "amber"} />
          {hard_mode && <StatChip label="Undos" value={undos_remaining} accent={undos_remaining > 0 ? "amber" : "red"} />}
          {is_dead && <StatChip label="State" value="FALLEN" accent="purple" />}
        </div>
      </div>

      <div>
        <div className="text-[0.6rem] uppercase tracking-widest gold mb-2">Attributes</div>
        <div className="space-y-1.5">
          {Object.entries(stats).map(([k, v]) => (
            <StatRow key={k} label={k} value={v} />
          ))}
        </div>
      </div>

      <div>
        <div className="text-[0.6rem] uppercase tracking-widest gold mb-2">Inventory</div>
        <ul className="space-y-1 font-serif-body text-sm text-stone-300">
          {inventory.length === 0 && <li className="text-stone-600 italic">— empty —</li>}
          {inventory.map((item, i) => (
            <li key={`${item}-${i}`} className="border-l border-amber-500/30 pl-2">{item}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}

function StatChip({ label, value, accent = "amber" }) {
  const cls = {
    amber: "border-amber-500/30 text-amber-300",
    red: "border-red-500/40 text-red-300",
    purple: "border-purple-500/40 text-purple-300",
  }[accent];
  return (
    <div className={`border ${cls} rounded-sm px-2 py-1.5`}>
      <div className="text-[0.55rem] uppercase tracking-widest text-stone-500">{label}</div>
      <div className="text-sm">{value}</div>
    </div>
  );
}

function StatRow({ label, value }) {
  if (value && typeof value === "object" && "current" in value && "max" in value) {
    const pct = value.max ? (value.current / value.max) * 100 : 0;
    return (
      <div>
        <div className="flex justify-between text-[0.65rem] uppercase tracking-widest text-stone-400">
          <span>{label}</span>
          <span className="text-stone-200">{value.current} / {value.max}</span>
        </div>
        <div className="h-1 mt-1 bg-stone-800 rounded-sm overflow-hidden">
          <div className="h-full bg-gradient-to-r from-amber-500 to-amber-700 transition-all duration-500" style={{ width: `${pct}%` }} />
        </div>
      </div>
    );
  }
  return (
    <div className="flex justify-between border-b border-stone-800/60 pb-1">
      <span className="text-[0.65rem] uppercase tracking-widest text-stone-400">{label}</span>
      <span className="text-stone-200">{Array.isArray(value) ? value.join(", ") : String(value)}</span>
    </div>
  );
}
